export default __webpack_public_path__ + "static/media/centerBr1.5077889a.png";